var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#CCD5E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 48,
    r: 39,
    fill: "#002E81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.65 48.3c0-5.767 1.033-10.283 3.1-13.55 2.1-3.267 5.567-4.9 10.4-4.9s8.283 1.633 10.35 4.9c2.1 3.267 3.15 7.783 3.15 13.55 0 5.8-1.05 10.35-3.15 13.65-2.067 3.3-5.517 4.95-10.35 4.95-4.833 0-8.3-1.65-10.4-4.95-2.067-3.3-3.1-7.85-3.1-13.65Zm20.1 0c0-2.467-.167-4.533-.5-6.2-.3-1.7-.933-3.083-1.9-4.15-.933-1.067-2.333-1.6-4.2-1.6s-3.283.533-4.25 1.6c-.933 1.067-1.567 2.45-1.9 4.15-.3 1.667-.45 3.733-.45 6.2 0 2.533.15 4.667.45 6.4.3 1.7.933 3.083 1.9 4.15.967 1.033 2.383 1.55 4.25 1.55s3.283-.517 4.25-1.55c.967-1.067 1.6-2.45 1.9-4.15.3-1.733.45-3.867.45-6.4Zm14.424 10.8c3.2-2.667 5.75-4.883 7.65-6.65 1.9-1.8 3.484-3.667 4.75-5.6 1.267-1.933 1.9-3.833 1.9-5.7 0-1.7-.4-3.033-1.2-4-.8-.967-2.033-1.45-3.7-1.45-1.666 0-2.95.567-3.85 1.7-.9 1.1-1.366 2.617-1.4 4.55h-6.8c.134-4 1.317-7.033 3.55-9.1 2.267-2.067 5.134-3.1 8.6-3.1 3.8 0 6.717 1.017 8.75 3.05 2.034 2 3.05 4.65 3.05 7.95 0 2.6-.7 5.083-2.1 7.45-1.4 2.367-3 4.433-4.8 6.2-1.8 1.733-4.15 3.833-7.05 6.3h14.75v5.8h-24.7v-5.2l2.6-2.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.39a927cb2f018303bf20520b46c63eb7.svg";
export { ForwardRef as ReactComponent };